<template>
  <ChecklistTableTaskCellWrapper :clickable="isStatusEditionEnabled"
                                 data-locator="status-area"
                                 @click="onStatusClick"
  >
    <div class="ChecklistTableTaskStatus">
      <div class="ChecklistTableTaskStatus__chip-container"
          :style="statusContainerStyles"
      >
        <AppTooltip>
          <template #activator="{ props }">
            <v-chip :color="computedStatusColor"
                    class="text-text-inverted text--bold"
                    :class="{'clickable': isStatusEditionEnabled}"
                    data-locator="task-status"
                    v-bind="props"
                    variant="flat"
                    size="small"
            >
              <template v-if="taskStatusCategoriesPending && !statusLabel">
                <v-progress-circular
                  color="icon-inverted"
                  indeterminate
                  size="14"
                  width="2"
                />
              </template>
              <template v-else>
                {{ statusLabel }}
              </template>
            </v-chip>
          </template>
          <span>{{ statusLabel }}</span>
        </AppTooltip>
      </div>
    </div>
  </ChecklistTableTaskCellWrapper>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import AppTooltip from '@/common/AppTooltip.vue'
import { getStatusDetailsByTaskInformation } from '@/common/utils/checklist'
import { statusColors } from '@/project/checklist/dialogs/taskStatus'
import ChecklistTableTaskCellWrapper from '@/project/checklist/table/ChecklistTableTaskCellWrapper.vue'

export default {
  name: 'ChecklistTableTaskStatus',
  components: { AppTooltip, ChecklistTableTaskCellWrapper },
  props: {
    mnemo: {
      type: String,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState('checklist', ['taskStatusCategories', 'taskStatusCategoriesPending']),
    ...mapGetters('groups', ['currentUserGroupId']),
    ...mapGetters('room', ['isCurrentUserPm']),
    ...mapGetters('user', ['currentUserId']),
    canCurrentUserEditStatus () {
      return this.isCurrentUserPm ||
      !!this.item.rights?.validators?.users?.find(user => user.id === this.currentUserId) ||
      !!this.item.rights?.validators?.groups?.find(group => group.id === this.currentUserGroupId) ||
      !!this.item.rights?.responsibles?.users?.find(user => user.id === this.currentUserId) ||
      !!this.item.rights?.responsibles?.groups?.find(group => group.id === this.currentUserGroupId)
    },
    computedStatusColor () {
      if (this.isAwaitingDeleteValidation) return statusColors.awaiting_delete_validation

      return this.item?.status?.color || statusColors[this.statusCategory] || statusColors.draft
    },
    isAwaitingDeleteValidation () {
      return this.item.isAwaitingValidation
    },
    isStatusEditionEnabled () {
      return !this.isAwaitingDeleteValidation && this.canCurrentUserEditStatus
    },
    statusCategory () {
      if (this.taskStatusCategories[this.item?.status?.category]) {
        return this.item?.status?.category
      }

      return null
    },
    statusLabel () {
      if (this.isAwaitingDeleteValidation) {
        return this.$t('project.project-settings.ProjectSettingsFeatures.checklist.pendingDeletion')
      }
      if (this.statusCategory) {
        const status = getStatusDetailsByTaskInformation(this.item?.status?.id, this.statusCategory, this.taskStatusCategories)
        if (status) {
          return status.label
        }
      }
      return this.taskStatusCategories['draft'][0]?.label || null
    },
    statusContainerStyles () {
      if (this.isAwaitingDeleteValidation) {
        return {
          clickable: false,
        }
      }
      return {
        clickable: this.item.canWriteStatus,
      }
    },
  },
  methods: {
    onStatusClick () {
      if (this.isStatusEditionEnabled) {
        this.$emit('edit-status')
      }
    },
  },
}
</script>
